import BaseFilters from './BaseFilters';

export default {
  ...BaseFilters.RemoteFilter,
  name: 'environmentId',
  label: 'global.text.environment',
  apiRoute: 'environment/paged',
  params: {
    ...BaseFilters.RemoteFilter.params,
    select: 'id,name',
    orderBy: 'name asc',
  },
};
